export default __webpack_public_path__ + "static/media/dialtone.fb05e764.mp3";